'use client'

import type { ChainId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import { DataList } from '@morpho-org/ui-v6/client'
import { memo } from 'react'

import { RiskDisclosureText } from '@/components/VaultPage/components/RiskDisclosureText'
import { getRiskDisclosure } from '@/config/risk-disclosures'

interface VaultV2RiskDisclosuresClientProps {
  chainId: ChainId
  vaultAddress: Address
}

const VaultV2RiskDisclosuresClient = ({
  chainId,
  vaultAddress
}: VaultV2RiskDisclosuresClientProps) => {
  const riskDisclosure = getRiskDisclosure(chainId, vaultAddress)

  return (
    <DataList.Root fullWidth>
      <DataList.Column>
        <RiskDisclosureText
          content={riskDisclosure?.disclosure ?? 'Curator has not submitted a Disclosure.'}
        />
      </DataList.Column>
    </DataList.Root>
  )
}

export default memo(VaultV2RiskDisclosuresClient)
